export const columns = [
  {
    title: "材料名称",
    dataIndex: "materialName",
    key: "materialName",
  },
];
